import { render } from "./footer.vue?vue&type=template&id=1f879432&scoped=true"
import script from "./footer.vue?vue&type=script&lang=js"
export * from "./footer.vue?vue&type=script&lang=js"

import "./footer.vue?vue&type=style&index=0&id=1f879432&lang=scss&scoped=true"

import exportComponent from "E:\\My Websites\\v12\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f879432"]])

export default __exports__